module.exports = __webpack_public_path__ + "img/close.d3868cc1.png";